<template>
  <div class="content">
    <section>
      <h2>
        一、新增房源
        <a @click="downloadExampleHouse">【 下载示例模版 】</a>
      </h2>
      <div>
        <label>房源表：</label>
        <input type="file" @change="excelData" />
      </div>
      <a-button
        class="submitStyle"
        type="primary"
        @click="submitBatchAddHouse"
        >{{ upDataHouseText }}</a-button
      >
    </section>
    <section>
      <h2>
        二、批量派单
        <a @click="downloadExampleOrder">【 下载示例模版 】</a>
      </h2>
      <div>
        <label>排期表：</label>
        <input type="file" @change="excelDataOrder" />
      </div>
      <a-button class="submitStyle" type="primary" @click="submitBatchForm">{{
        upDataFormText
      }}</a-button>
    </section>
    <section>
      <h2>
        三、批量更改密码
        <a @click="downloadExamplePassword">【 下载示例模版 】</a>
      </h2>
      <div>
        <label>房源表：</label>
        <input type="file" @change="excelDataPassword" />
      </div>
      <a-button
        class="submitStyle"
        type="primary"
        @click="submitBatchPassword"
        >{{ upDataPasswordText }}</a-button
      >
    </section>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      houseFile: "",
      upDataHouseText: "提交",
      orderFile: "",
      upDataFormText: "提交",
      passwordFile: "",
      upDataPasswordText: "提交"
    };
  },
  methods: {
    downloadExampleHouse() {
      window.location.href =
        this.httpsBasic.url +
        this.httpsBasic.clean +
        "House/downBatchHouseTemplate?token=" +
        window.localStorage.getItem("xnwfPcToken");
    },
    downloadExampleOrder() {
      window.location.href =
        this.httpsBasic.url +
        this.httpsBasic.clean +
        "Work_order/downBatchAssignOrderTemplate?token=" +
        window.localStorage.getItem("xnwfPcToken");
    },
    submitBatchAddHouse() {
      let _this = this;
      if (this.houseFile != "") {
        this.$confirm({
          title: "表格一旦上传，房源将自动新建，确认无误后进行操作?",
          okText: "确认",
          okType: "danger",
          cancelText: "取消",
          onOk() {
            _this.upExcel();
          },
          onCancel() {
            // console.log("Cancel");
          }
        });
      } else {
        this.$message.warning("请选择规定格式的Excel上传！");
      }
    },
    upExcel() {
      this.upDataHouseText = "上传中...";
      let formData = new FormData();
      formData.append("excel", this.houseFile);
      formData.append("token", window.localStorage.getItem("xnwfPcToken"));
      let config = {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      };
      let url =
        this.httpsBasic.url + this.httpsBasic.clean + "House/uploadBatchHouse";
      axios
        .post(url, formData, config)
        .then(res => {
          if (res.data.code == 200) {
            this.$message.success("上传成功");
            this.houseFile = "";
            this.$emit("hideInSendOrder", false);
          } else {
            this.$message.warning(res.data.message);
          }
          this.upDataHouseText = "上传";
        })
        .catch(err => {
          this.$message.error(err);
          this.upDataHouseText = "上传";
        });
    },
    excelData(e) {
      this.houseFile = e.target.files[0];
    },
    excelDataOrder(e) {
      this.orderFile = e.target.files[0];
    },
    submitBatchForm() {
      let _this = this;
      if (this.orderFile != "") {
        this.$confirm({
          title: "表格一旦上传，工单将自动新建，确认无误后进行操作?",
          okText: "确认",
          okType: "danger",
          cancelText: "取消",
          onOk() {
            _this.UpOrderExcel();
          },
          onCancel() {
            // console.log("Cancel");
          }
        });
      } else {
        this.$message.warning("请选择规定格式的Excel上传！");
      }
    },
    UpOrderExcel() {
      this.upDataFormText = "上传中...";
      let formData = new FormData();
      formData.append("excel", this.orderFile);
      formData.append("token", window.localStorage.getItem("xnwfPcToken"));
      let config = {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      };
      let url =
        this.httpsBasic.url +
        this.httpsBasic.clean +
        "Work_order/uploadBatchAssignOrder";
      axios
        .post(url, formData, config)
        .then(res => {
          if (res.data.code == 200) {
            this.$message.success("上传成功");
            this.orderFile = "";
            this.$emit("hideInSendOrder", false);
          } else {
            this.$info({
              title: "提示",
              content: res.data.message,
              onOk() {}
            });
            // this.$message.warning(res.data.message);
          }
          this.upDataFormText = "上传";
        })
        .catch(err => {
          this.$message.error(err);
          this.upDataFormText = "上传";
        });
    },
    excelDataPassword(e) {
      this.passwordFile = e.target.files[0];
    },
    downloadExamplePassword() {
      window.location.href =
        this.httpsBasic.url +
        this.httpsBasic.clean +
        "House/uploadBatchUpdatePasswordTemplate?token=" +
        window.localStorage.getItem("xnwfPcToken");
    },
    submitBatchPassword() {
      let _this = this;
      if (this.passwordFile != "") {
        this.$confirm({
          title: "表格一旦上传，相关房源密码全部更改，确认无误后进行操作?",
          okText: "确认",
          okType: "danger",
          cancelText: "取消",
          onOk() {
            _this.UpPasswordExcel();
          },
          onCancel() {
            // console.log("Cancel");
          }
        });
      } else {
        this.$message.warning("请选择规定格式的Excel上传！");
      }
    },
    UpPasswordExcel() {
      this.upDataPasswordText = "上传中...";
      let formData = new FormData();
      formData.append("excel", this.passwordFile);
      formData.append("token", window.localStorage.getItem("xnwfPcToken"));
      let config = {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      };
      let url =
        this.httpsBasic.url +
        this.httpsBasic.clean +
        "House/uploadBatchUpdatePassword";
      axios
        .post(url, formData, config)
        .then(res => {
          if (res.data.code == 200) {
            this.$message.success("上传成功");
            this.passwordFile;
            this.$emit("hideInSendOrder", false);
          } else {
            this.$info({
              title: "提示",
              content: res.data.message,
              onOk() {}
            });
            // this.$message.warning(res.data.message);
          }
          this.upDataPasswordText = "上传";
        })
        .catch(err => {
          this.$message.error(err);
          this.upDataPasswordText = "上传";
        });
    }
  }
};
</script>
<style lang="less" scoped>
.content {
  margin: 30px 4%;
  > section {
    margin-bottom: 80px;
    h2 {
      font-size: 16px;
      line-height: 22px;
      margin-bottom: 10px;
      font-weight: normal;
      a {
        font-size: 12px;
      }
    }
    > div {
      margin: 20px 0;
    }
    .submitStyle {
      margin-left: 60px;
    }
  }
}
</style>
